import { z } from 'zod'

export const GetTimeSchema = z.object({
  from: z.string().nullish(),
  to: z.string().nullish(),
  type: z.enum(['by', 'at', 'between', '24', 'tbc', 'asap']).default('between').optional(),
})
